import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { useServiceHealth } from '@/hooks/useAdminMonitoring';
import { Zap } from 'lucide-react';

export function RedisMetrics() {
  const { data } = useServiceHealth();
  // Health API returns { status, timestamp, services: { database: {...}, redis: {...}, minio: {...} } }
  const redis = data?.services?.redis;

  return (
    <Card>
      <CardHeader title="Redis" />
      <CardContent>
        <div className="flex items-center gap-3">
          <Zap className="h-8 w-8 text-warning-500" />
          <div>
            <p className="text-sm font-medium text-neutral-700 dark:text-neutral-200">Statut</p>
            <p className="text-lg font-bold text-neutral-900 dark:text-neutral-100">{redis?.status ?? '--'}</p>
            {redis?.latency != null && (
              <p className="text-xs text-neutral-500">{redis.latency}ms latence</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
